export const EnVar={
	//apiurl:'https://alicorn.co/api/',
	apiurl:'http://api.sssbk.in/api/',
}
